/** Human-friendly label for portal-only client users (avoids raw login ids like `78asddw`). */
export function resolvePortalClientUserDisplayName(
  name: string | null | undefined,
  userName: string | null | undefined,
  email: string | null | undefined
): string | null {
  const trimmedName = trimToNull(name);
  const trimmedLogin = trimToNull(userName);
  const trimmedEmail = trimToNull(email);

  if (isMeaningfulPersonName(trimmedName, trimmedLogin)) {
    return trimmedName;
  }

  const emailLocal = emailLocalPart(trimmedEmail);
  if (emailLocal) {
    return formatLabel(emailLocal);
  }

  if (trimmedName) {
    return trimmedName;
  }

  if (trimmedLogin) {
    return trimmedLogin;
  }

  return trimmedEmail;
}

function isMeaningfulPersonName(candidate: string | null, loginId: string | null): boolean {
  if (!candidate) {
    return false;
  }
  if (candidate.includes(' ')) {
    return true;
  }
  if (loginId && candidate.toLowerCase() === loginId.toLowerCase()) {
    return false;
  }
  if (/\d/.test(candidate)) {
    return false;
  }
  return true;
}

function emailLocalPart(email: string | null): string | null {
  if (!email) {
    return null;
  }
  const at = email.indexOf('@');
  if (at <= 0) {
    return null;
  }
  const local = email.slice(0, at).trim();
  return local.length > 0 ? local : null;
}

function formatLabel(value: string): string {
  const t = value.trim();
  if (!t) {
    return t;
  }
  const spaced = t.replace(/\./g, ' ').replace(/_/g, ' ');
  if (spaced.includes(' ')) {
    return spaced
      .split(/\s+/)
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + (w.length > 1 ? w.slice(1).toLowerCase() : ''))
      .join(' ');
  }
  return t.charAt(0).toUpperCase() + (t.length > 1 ? t.slice(1) : '');
}

function trimToNull(value: string | null | undefined): string | null {
  const t = (value ?? '').trim();
  return t.length > 0 ? t : null;
}
